import request from '@/axios'

// 获取群客户信息
export function getFlockproPrietorInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getFlockproPrietorInfo',
    method: 'post',
    data
  })
}

// 添加勘测邀请函
export function saveMeasureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/saveMeasureInvite',
    method: 'post',
    data
  })
}

// 获取勘测邀请函
export function getMeasureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureInvite',
    method: 'post',
    data
  })
}

// 客户确认勘测邀请
export function determineMeasure(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/determineMeasure',
    method: 'post',
    data
  })
}

// 05-获取勘测报告
export function getMeasureInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureInfo',
    method: 'post',
    data
  })
}

// 06-获取勘测状态
export function getMeasureStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureStatus',
    method: 'post',
    data
  })
}

// 07-添加勘测评价
export function saveMeasureEvaluation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/saveMeasureEvaluation',
    method: 'post',
    data
  })
}

// 08-获取勘测评价
export function getMeasureEvaluation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureEvaluation',
    method: 'post',
    data
  })
}

// 09-获取勘测基础信息
export function getMeasureBaseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureBaseInfo',
    method: 'post',
    data
  })
}

// (新)05-获取勘测报告
export function getMeasureReport(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureReport',
    method: 'post',
    data
  })
}
